// Generated by purs version 0.15.15
import * as Color from "../Color/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Visonum_Cross_Types_Brand_ANW from "../Visonum.Cross.Types.Brand.ANW/index.js";
import * as Visonum_Cross_Types_Brand_Visonum from "../Visonum.Cross.Types.Brand.Visonum/index.js";
import * as Visonum_Cross_Types_Brand_Vodafone from "../Visonum.Cross.Types.Brand.Vodafone/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var BrandVisonumIsSymbol = {
    reflectSymbol: function () {
        return "BrandVisonum";
    }
};
var BrandANWIsSymbol = {
    reflectSymbol: function () {
        return "BrandANW";
    }
};
var BrandVodafoneIsSymbol = {
    reflectSymbol: function () {
        return "BrandVodafone";
    }
};
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum);
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var BrandVisonum = /* #__PURE__ */ (function () {
    function BrandVisonum() {

    };
    BrandVisonum.value = new BrandVisonum();
    return BrandVisonum;
})();
var BrandANW = /* #__PURE__ */ (function () {
    function BrandANW() {

    };
    BrandANW.value = new BrandANW();
    return BrandANW;
})();
var BrandVodafone = /* #__PURE__ */ (function () {
    function BrandVodafone() {

    };
    BrandVodafone.value = new BrandVodafone();
    return BrandVodafone;
})();
var genericBrand_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return BrandVisonum.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return BrandANW.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return BrandVodafone.value;
        };
        throw new Error("Failed pattern match at Visonum.Cross.Types.Brand (line 67, column 1 - line 67, column 32): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof BrandVisonum) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof BrandANW) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof BrandVodafone) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Visonum.Cross.Types.Brand (line 67, column 1 - line 67, column 32): " + [ x.constructor.name ]);
    }
};
var showBrand = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericBrand_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(BrandVisonumIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(BrandANWIsSymbol))(/* #__PURE__ */ genericShowConstructor(BrandVodafoneIsSymbol))))
};
var eqBrand = {
    eq: function (x) {
        return function (y) {
            if (x instanceof BrandVisonum && y instanceof BrandVisonum) {
                return true;
            };
            if (x instanceof BrandANW && y instanceof BrandANW) {
                return true;
            };
            if (x instanceof BrandVodafone && y instanceof BrandVodafone) {
                return true;
            };
            return false;
        };
    }
};
var ordBrand = {
    compare: function (x) {
        return function (y) {
            if (x instanceof BrandVisonum && y instanceof BrandVisonum) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof BrandVisonum) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof BrandVisonum) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof BrandANW && y instanceof BrandANW) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof BrandANW) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof BrandANW) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof BrandVodafone && y instanceof BrandVodafone) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Visonum.Cross.Types.Brand (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqBrand;
    }
};
var enumBrand = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericBrand_)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericBrand_)(genericEnumSum1),
    Ord0: function () {
        return ordBrand;
    }
};
var encodeJsonBrand = {
    encodeJson: /* #__PURE__ */ Data_Argonaut_Encode_Generic.genericEncodeJson(genericBrand_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(BrandVisonumIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(BrandANWIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(BrandVodafoneIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))
};
var defaultBrand = /* #__PURE__ */ (function () {
    return {
        def: BrandVisonum.value
    };
})();
var decodeJsonBrand = {
    decodeJson: /* #__PURE__ */ Data_Argonaut_Decode_Generic.genericDecodeJson(genericBrand_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(BrandVisonumIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(BrandANWIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(BrandVodafoneIsSymbol))))
};
var boundedBrand = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericBrand_)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericBrand_)(genericBottomSum),
    Ord0: function () {
        return ordBrand;
    }
};
var toTheme = function (v) {
    if (v instanceof BrandVisonum) {
        return Visonum_Cross_Types_Brand_Visonum.themeVisonum;
    };
    if (v instanceof BrandANW) {
        return Visonum_Cross_Types_Brand_ANW.themeANW;
    };
    if (v instanceof BrandVodafone) {
        return Visonum_Cross_Types_Brand_Vodafone.themeVodafone;
    };
    throw new Error("Failed pattern match at Visonum.Cross.Types.Brand (line 54, column 11 - line 57, column 33): " + [ v.constructor.name ]);
};
var print = function (v) {
    if (v instanceof BrandVisonum) {
        return "visonum";
    };
    if (v instanceof BrandANW) {
        return "anw";
    };
    if (v instanceof BrandVodafone) {
        return "vodafone";
    };
    throw new Error("Failed pattern match at Visonum.Cross.Types.Brand (line 35, column 9 - line 38, column 30): " + [ v.constructor.name ]);
};
var parse = function (v) {
    if (v === "visonum") {
        return new Data_Maybe.Just(BrandVisonum.value);
    };
    if (v === "anw") {
        return new Data_Maybe.Just(BrandANW.value);
    };
    if (v === "vodafone") {
        return new Data_Maybe.Just(BrandVodafone.value);
    };
    return Data_Maybe.Nothing.value;
};
var fromHostName = function (hostname) {
    if (hostname === "speedtest.anw.net") {
        return new Data_Maybe.Just(BrandANW.value);
    };
    if (hostname === "www.vodafone.de") {
        return new Data_Maybe.Just(BrandVodafone.value);
    };
    return Data_Maybe.Nothing.value;
};
var defaultColor = /* #__PURE__ */ fromJust(/* #__PURE__ */ Color.fromHexString("#ff0000"));
export {
    BrandVisonum,
    BrandANW,
    BrandVodafone,
    defaultColor,
    fromHostName,
    parse,
    print,
    toTheme,
    genericBrand_,
    encodeJsonBrand,
    decodeJsonBrand,
    defaultBrand,
    showBrand,
    eqBrand,
    ordBrand,
    enumBrand,
    boundedBrand
};
